import React, {useEffect} from 'react'
import $ from "jquery"
import useTranslation from "../hooks/useTranslation";

function Home() {
    const { t } = useTranslation();

    useEffect(() => {
        $('.App').css('backgroundImage', 'none')
    }, [])

    return <div className="row w-100 justify-content-center align-items-center">
        <div className="col-lg-6">
            <div className="text-center">
                <img src={process.env.PUBLIC_URL + "/assets/img/error-image.png"}/>
            </div>
            <div className="text-center p-3">
                <h1>{t('something_went_wrong_error')}</h1>
                <h5 className="text-muted">{t('something_went_wrong_try_again')}</h5>
            </div>
        </div>
    </div>;

}

export default Home;
